import { render, staticRenderFns } from "./SubTagTab.vue?vue&type=template&id=fcc63e1c"
import script from "./SubTagTab.vue?vue&type=script&lang=js"
export * from "./SubTagTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports